// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

/**
 * A routing-policy rule — what makes traffic leave by the interface it
 * arrived on instead of following the main default route.
 */
export class RuleConfig implements flatbuffers.IUnpackableObject<RuleConfigT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): RuleConfig {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsRuleConfig(bb: flatbuffers.ByteBuffer, obj?: RuleConfig): RuleConfig {
    return (obj || new RuleConfig()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsRuleConfig(bb: flatbuffers.ByteBuffer, obj?: RuleConfig): RuleConfig {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new RuleConfig()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  on(): string | null;
  on(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  on(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * At least one of from/to. Both must be the same family: a v4 source
   * against a v6 destination matches nothing and is silently inert.
   */
  from(): string | null;
  from(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  from(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  to(): string | null;
  to(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  to(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * The table this rule directs matching traffic to. Integer only, same
   * reason as the route table above.
   *
   * 0 means unset, and is the one value the renderer rejects outright —
   * a rule with no table selects nothing. `FlatBuffers` cannot mark a scalar
   * required, so nothing on the wire distinguishes "unset" from a
   * deliberate 0; a writer that lets a rule through without one produces a
   * buffer that only fails at first boot, on a headless box. Validate it
   * where the rule is authored.
   */
  tableId(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  priority(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  mark(): number {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  static startRuleConfig(builder: flatbuffers.Builder) {
    builder.startObject(6);
  }

  static addOn(builder: flatbuffers.Builder, onOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, onOffset, 0);
  }

  static addFrom(builder: flatbuffers.Builder, fromOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, fromOffset, 0);
  }

  static addTo(builder: flatbuffers.Builder, toOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, toOffset, 0);
  }

  static addTableId(builder: flatbuffers.Builder, tableId: number) {
    builder.addFieldInt32(3, tableId, 0);
  }

  static addPriority(builder: flatbuffers.Builder, priority: number) {
    builder.addFieldInt32(4, priority, 0);
  }

  static addMark(builder: flatbuffers.Builder, mark: number) {
    builder.addFieldInt32(5, mark, 0);
  }

  static endRuleConfig(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createRuleConfig(
    builder: flatbuffers.Builder,
    onOffset: flatbuffers.Offset,
    fromOffset: flatbuffers.Offset,
    toOffset: flatbuffers.Offset,
    tableId: number,
    priority: number,
    mark: number,
  ): flatbuffers.Offset {
    RuleConfig.startRuleConfig(builder);
    RuleConfig.addOn(builder, onOffset);
    RuleConfig.addFrom(builder, fromOffset);
    RuleConfig.addTo(builder, toOffset);
    RuleConfig.addTableId(builder, tableId);
    RuleConfig.addPriority(builder, priority);
    RuleConfig.addMark(builder, mark);
    return RuleConfig.endRuleConfig(builder);
  }

  unpack(): RuleConfigT {
    return new RuleConfigT(
      this.on(),
      this.from(),
      this.to(),
      this.tableId(),
      this.priority(),
      this.mark(),
    );
  }

  unpackTo(_o: RuleConfigT): void {
    _o.on = this.on();
    _o.from = this.from();
    _o.to = this.to();
    _o.tableId = this.tableId();
    _o.priority = this.priority();
    _o.mark = this.mark();
  }

  unpackFields(...fields: string[]): RuleConfigT {
    const t = new RuleConfigT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("on")) {
      t.on = this.on();
    }
    if (fieldSet.has("from")) {
      t.from = this.from();
    }
    if (fieldSet.has("to")) {
      t.to = this.to();
    }
    if (fieldSet.has("table_id")) {
      t.tableId = this.tableId();
    }
    if (fieldSet.has("priority")) {
      t.priority = this.priority();
    }
    if (fieldSet.has("mark")) {
      t.mark = this.mark();
    }
    return t;
  }
}

export class RuleConfigT implements flatbuffers.IGeneratedObject {
  constructor(
    public on: string | Uint8Array | null = null,
    public from: string | Uint8Array | null = null,
    public to: string | Uint8Array | null = null,
    public tableId: number = 0,
    public priority: number = 0,
    public mark: number = 0,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const on = this.on !== null ? builder.createString(this.on!) : 0;
    const from = this.from !== null ? builder.createString(this.from!) : 0;
    const to = this.to !== null ? builder.createString(this.to!) : 0;

    return RuleConfig.createRuleConfig(
      builder,
      on,
      from,
      to,
      this.tableId,
      this.priority,
      this.mark,
    );
  }

  clone(): RuleConfigT {
    const obj = new RuleConfigT();
    obj.on = this.on;
    obj.from = this.from;
    obj.to = this.to;
    obj.tableId = this.tableId;
    obj.priority = this.priority;
    obj.mark = this.mark;
    return obj;
  }

  equals(other: RuleConfigT): boolean {
    if (this.on !== other.on) return false;
    if (this.from !== other.from) return false;
    if (this.to !== other.to) return false;
    if (this.tableId !== other.tableId) return false;
    if (this.priority !== other.priority) return false;
    if (this.mark !== other.mark) return false;
    return true;
  }
}

export function verifyRuleConfig(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 10, 4);
    verifier.checkScalarField(tablePos, 12, 4);
    verifier.checkScalarField(tablePos, 14, 4);
  } finally {
    verifier.popDepth();
  }
}
